(() => {
  const MOBILE_QUERY = '(max-width: 768px)';

  const resetMobileGrid = () => {
    localStorage.removeItem('gridColumns');

    const grid = document.getElementById('product-grid');
    if (!grid) return;

    grid.classList.remove(
      'collection-product-list--1',
      'collection-product-list--2',
      'collection-product-list--3',
      'collection-product-list--4'
    );
    grid.classList.add('collection-product-list--2');
  };

  const placeLayoutControls = () => {
    if (!document.body.classList.contains('template-collection')) return;

    document
      .querySelectorAll('.collection-top__mobile-layout-toggler')
      .forEach((control) => control.remove());

    const desktopControls = document.querySelector('.collection-top__layout-toggler');
    const existingWrapper = document.querySelector('.jeanius-floating-layout-controls');

    if (window.matchMedia(MOBILE_QUERY).matches) {
      desktopControls?.remove();
      existingWrapper?.remove();
      resetMobileGrid();
      return;
    }

    if (!desktopControls) return;

    if (localStorage.getItem('gridColumns') === '1') {
      localStorage.setItem('gridColumns', '3');
    }

    let wrapper = existingWrapper;
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'jeanius-floating-layout-controls';
      wrapper.setAttribute('aria-label', 'Change product grid layout');
      document.body.appendChild(wrapper);
    }

    wrapper.appendChild(desktopControls);
  };

  const start = () => placeLayoutControls();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', placeLayoutControls);
})();
